import { Fragment, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FailedPayment = () => {
    const { t } = useTranslation();

    const history = useHistory();
    useEffect(() => {
        window.addEventListener('popstate', () => { history.replace("/") });
        return () => {
            window.removeEventListener('popstate', () => { history.replace("/") });
        };
    }, []);

  return (
    <Fragment>
          <h2 className="mb-7 ta-c">{t("result.failedTitle")}</h2>
          <p className="ta-c">{t("result.failedDescription")}</p>
          <Link to='/' className='secondary-button mt-7'>{t("result.back")}</Link>
    </Fragment>
  );
};

export default FailedPayment;
